import React from 'react'
import styled from 'styled-components'
import { OptionButton } from '../OptionButton'

interface Props {
  onClick: () => void
  className?: string
}

export function MaxButton({ className, onClick }: Props) {
  return (
    <Button className={className} title="Input maximum amount" onClick={onClick}>
      Max
    </Button>
  )
}

const Button = styled(OptionButton)`
  margin: 0 6px;
`
